<template>
  <div>

    <vx-card>
      <vs-row vs-type="flex">
        <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
          <vs-row  vs-type="flex" >
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <label>Nome</label>
              <vs-select
                v-model="companyGuid"
                autocomplete
                class="w-full">
                <vs-select-item :key="index" :value="item.guid" :text="item.name" v-for="(item, index) in companies" class="w-full"/>
              </vs-select>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <label>Cnpj</label>
              <vs-select
                v-model="companyGuid"
                autocomplete
                class="w-full">
                <vs-select-item :key="index" :value="item.guid" :text="(item.cnpjAlfa || item.cnpj) | formatCnpj" v-for="(item, index) in companies" class="w-full"/>
              </vs-select>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-lg="4" vs-sm="12" vs-xs="12" vs-align="center" class="mt-4">
          <vs-row vs-align="center" >
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mt-1">
              <vs-button
                class="w-full"
                @click="clearFilter()"
                icon-pack="fa"
                icon="fa-eraser"
                title="Limpar">
                <span class="auto-hide-clear-text">Limpar</span>
              </vs-button>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mt-1">
              <vs-button
                class="w-full"
                @click="refine()"
                icon="search">Buscar
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card class="mt-4">
      <CceeChart :values="values"/>
    </vx-card>

    <vx-card class="mt-4">
      <vs-row class="mb-4">
        <vs-col>
          <vs-button @click="download">Download</vs-button>
        </vs-col>
      </vs-row>

      <vs-table stripe :data="energyBalanceTable" noDataText="Nenhum registro encontrado.">

        <template slot="thead">
          <th>Empresa</th>
          <th>Cnpj</th>
          <th>Tipo</th>
          <th>Data</th>
          <th>Valor</th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(row, indextr) in data">
            <td>
              {{row.companyProfile.name}}
            </td>
            <td>
              {{(row.companyProfile.cnpjAlfa || row.companyProfile.cnpj) | formatCnpj}}
            </td>
            <td>
              <span v-if="row.balanceType === 'PURCHASE'">Compra</span>
              <span v-else-if="row.balanceType === 'SALE'">Venda</span>
              <span v-else> - </span>
            </td>
            <td>
              {{row.date | formatDate}}
            </td>
            <td>
              {{row.value | toDecimal}}
            </td>
          </vs-tr>
        </template>

      </vs-table>
    </vx-card>

  </div>
</template>

<script>
import axios from 'axios'
import CceeChart from "@/components/stats/CceeChart";
import NumericInput from "@/components/NumericInput";

export default {
  name: "Historico",
  components: {
    CceeChart,
    NumericInput
  },
  data () {
    return {
      companies: [],
      energyBalanceTable: [],
      companyGuid: '',
      values: [
        {
          label: '',
          labels: [],
          datasets: [],
          data: [],
        }
      ],
    }
  },
  beforeMount() {
    this.loadCompanies()
  },
  methods: {

    loadCompanies () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company/profiles`, {
        params: {
          profile: 'TRADER'
        }
      })
        .then((response) => {
          this.companies = response.data
        })
    },

    refine () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/ccee/trader/${this.companyGuid}/chart`)
        .then((response) => {
          if (response.data.length > 0) {
            this.values = response.data
          } else {
            this.values = [
              {
                label: '',
                labels: [],
                datasets: [],
                data: [],
              }
            ]
          }

        })

      axios.get(`${process.env.VUE_APP_API}/api/v1/ccee/trader/${this.companyGuid}`)
        .then((response) => {
          this.energyBalanceTable = response.data
        })

    },

    clearFilter() {
      this.companyGuid = ''
    },

    download() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/ccee/trader/${this.companyGuid}/excel`,
        {
          responseType: 'blob'
        })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const filename = response.headers["x-suggested-filename"];
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      })
    }

  }
}
</script>

<style scoped>

</style>
